<template>
	<div class="screen-wrapper2">
		<div style="height: 80px; width: 100%" v-if="fromUser == 'guizhou'"></div>
		<div class="screen screenBg" id="screen">
			<div class="demo-root">
				<div class="all">
					<video width="4576px" height="1935px" class="video" muted autoplay loop
						src="@/assets/images/exposition/xunidianchang2.mp4"></video>
				</div>
				<header>
					<MyHeader>
					</MyHeader>
					<!-- <myHeader title="协鑫数字能源虚拟电厂"> </myHeader> -->
				</header>

				<main>

					<div class="demo-left">
						<div class="demo-left-top">
							<demoLeftTop></demoLeftTop>
						</div>
						<div class="demo-left-center">
							<!-- <demoLeftCenter1></demoLeftCenter1> -->
							<demoLeftCenter2></demoLeftCenter2>
						</div>
						<div class="demo-left-bottom2">
							<div class="shuliangtongji">
								<div class="lefttitle lineHight1"><span class="title">运行中</span><span
										class="num">2</span><span class="danwei ">个</span></div>
								<div class="lefttitle lineHight2"><span class="title">筹建中</span><span
										class="num">4</span><span class="danwei ">个</span></div>
								<div class="lefttitle lineHight3"><span class="title">规划中</span><span
										class="num">7</span><span class="danwei ">个</span></div>
							</div>
							<div class="suanlishuliangbiaozhu"></div>
							<div class="yellow1"></div>
							<div class="yellow2"></div>
							<div class="yellow3"></div>
			<!-- 				<div v-show="!show3">
								<div class="robotButton" @click="clicktrue3()">
									<div class="shuzirenRound">
										<img  class="shuzirenRoundImg" src="~@/assets/images/exposition/humansmall.png" alt="">
									</div>
									<div class="shuzirenIcon1">
										<img class="shuzirenIconImg" v-if="show3===false"
											src="~@/assets/images/exposition/minimize.png" alt="">
										<img class="shuzirenIconImg" v-if="show3===true"
											src="~@/assets/images/exposition/maximize.png" alt="">
									</div>

								</div>
							</div> -->

							<!-- <leftBottomFooter></leftBottomFooter> -->
						</div>
					</div>
					<div class="demo-right2">
						<div class="demo-right-top2">
							<xunidianchangRightTop2></xunidianchangRightTop2>
						</div>
						<div class="demo-right-bottom2">
							<xunidianchangRightBottom2></xunidianchangRightBottom2>
						</div>
					</div>
				</main>
				<!-- <footer>
            <myFooter></myFooter>
        </footer> -->
			</div>
			<myFooter></myFooter>
			<!-- <div v-show="show3" class="robot">
				<newRobot></newRobot>
				 <div class="rightBtn"  v-show="show1">
					<img class="rightBtnImg" src="~@/assets/images/exposition/rightRound.png" alt="">
					<div class="title">正在执行策略1</div>
				</div> -->
			<!-- </div> --> 

		</div>
	</div>
</template>

<script>
	import MyHeader from '@/views/components/MyHeader.vue'
	import demoLeftTop from "./components/demoLeftTop.vue";
	import xunidianchangRightBottom2 from "./components/xunidianchangRightBottom2.vue";
	import xunidianchangRightTop2 from "./components/xunidianchangRightTop2.vue";
	// import leftBottomFooter from "./components/leftBottomFooter.vue";
	// import demoLeftCenter1 from "./components/demoLeftCenter1.vue";
	import demoLeftCenter2 from "./components/demoLeftCenter2.vue";
	import newRobot from "./components/robat/index.vue";
	import myFooter from '@/views/exposition/components/myFooter.vue'
	export default {
		components: {
			MyHeader,
			xunidianchangRightBottom2,
			xunidianchangRightTop2,
			// leftBottomFooter,
			demoLeftTop,
			myFooter,
			// demoLeftCenter1,
			demoLeftCenter2,
			// newRobot
		},
		provide() {
			return {
				// injectData: ()=>this.show1
			};
		},
		data() {
			return {
				show3: false,
				pageInterval: null,
				intervalNum: 30,
				fromUser: "",
				end:false

			};
		},
		beforeCreate() {
			console.log("this.$route====333=======", this.$route.query.fromScreen);
			if (this.$route.query.fromScreen) {
				sessionStorage.setItem("fromScreen", this.$route.query.fromScreen);
			}
			localStorage.setItem("harbour_id", "76df7579ccc24d2693f6488c38a3a0b0");
			let fromPath = localStorage.getItem("newBigScreen::fromPath");
			let playCount = parseInt(
				localStorage.getItem("newBigScreen::playCount") || 0,
				10
			);
			if (fromPath && ++playCount >= 2) {
				localStorage.setItem("newBigScreen::playCount", "0");
				localStorage.setItem("newBigScreen::fromPath", "");
				location.reload();
			} else {
				localStorage.setItem("newBigScreen::playCount", playCount + "");
			}
		},
		mounted() {
			this.$EventBus.$on('isActiveEnd', (isActiveEnd) => {
				  // this.clicktrue1(show1)
					console.log(isActiveEnd, 'this.isActiveEnd.isActiveEnd.isActiveEnd')
					if (isActiveEnd) {
						this.end = false;
						console.log(this.end, 'truethis.end.end.isActiveEnd')
					} else {
						this.end = true;
						console.log(this.end, 'falsethis.end.end.isActiveEnd')
					}
					
				})
			// this.$EventBus.$on('clicktrue2', (show2) => {
			// 	// this.clicktrue1(show1)
			// 	console.log(show2, 'this.show1this.show1this.show1111111111111')
			// 	if (show2) {
			// 		this.show3 = true;
			// 	} else {
			// 		this.show3 = false;
			// 	}

			// })
			document.title = "虚拟电厂SaaS管控平台监控";
			let {
				fromUser,
				scaleY
			} = this.$route.query;
			fromUser ? sessionStorage.setItem("fromUser", fromUser) : "";
			scaleY ? localStorage.setItem("newBigScreen::scaleY", scaleY) : "";

			let that = this;
			this.fromUser = sessionStorage.getItem("fromUser");
			// document.title = "移动能源光储充换车云一体化大屏";
			//初始化自适应  ----在刚显示的时候就开始适配一次
			that.handleScreenAuto();
			//绑定自适应函数   ---防止浏览器栏变化后不再适配
			window.onresize = function() {
				that.handleScreenAuto();
			};
			this.pageInterval = null
			if (sessionStorage.getItem('fromUser') != 'guizhou' && sessionStorage.getItem('fromUser') != 'suzhou') {
				this.pageInterval = setInterval(() => {
					console.log(this.end,'(this.end(this.end.isActiveEnd')
					if(this.end) return;
                    console.log(this.intervalNum,'this.intervalNumend.isActiveEnd')
					this.intervalNum--
					if (this.intervalNum < 0) {
						if (localStorage.getItem('IntervalStop') == 'stop') {
							return
						}
						// let localName = localStorage.getItem('exposition::pathName')
						// this.$router.push({
						// 	path: `/${localName || 'changingElectricity'}`
						// })
						this.$router.replace({
							path: 'energyStorage',
							query: {
								stationId: 'd13e09fd3c89459789d3933008d4bcfa'
							}
						})
					}
				}, 1000)

				// document.onmousemove = ((event) => {
				// 	// console.log(event)
				// 	this.intervalNum = this.intervalNumSet
				// })
			}
			// document.onmousemove = (() => {
			// 	this.intervalNum = this.intervalNumSet
			// })
			// }
		},
		deleted() {
			window.onresize = null;
		},
		methods: {
			//数据大屏自适应函数
			handleScreenAuto() {
				const designDraftWidth = 4576; //设计稿的宽度
				const designDraftHeight = 1935; //设计稿的高度
				//根据屏幕的变化适配的比例
				const scale =
					document.documentElement.clientWidth /
					document.documentElement.clientHeight <
					designDraftWidth / designDraftHeight ?
					document.documentElement.clientWidth / designDraftWidth :
					document.documentElement.clientHeight / designDraftHeight;
				//缩放比例

				// console.log(scale);

				document.querySelector(
					"#screen"
				).style.transform = `scale(${scale}) translate(-50%)`;
				// let scaleY = parseFloat(localStorage.getItem('newBigScreen::scaleY')) || 0.98
				// if (sessionStorage.getItem('fromUser') == 'guizhou') {
				// 	document.querySelector('#screen').style.transform = `scale(${scale}, ${scale * 1.6}) translate(-50%)`;
				// } else {
				// 	document.querySelector('#screen').style.transform =
				// 		`scale(${scale}, ${scale * scaleY}) translate(-50%)`;
				// }
			},
			// clicktrue3() {
			// 	console.log(123123123)
			// 	this.show3 = !this.show3;
			// 	this.$EventBus.$emit('clicktrue3', this.show3)
			// 	console.log(this.show3, 'this.show3')
			// }
		},
		destroyed() {
			clearInterval(this.pageInterval)
		},
	};
</script>

<style lang="scss" scope>
	@import "@/assets/scss/pc.scss";
	@import "@/assets/scss/main-map.scss";

	@font-face {
		font-family: "DS-Digital-Bold";
		src: url("~@/assets/font/DS-Digital-Bold.ttf");
	}

	@font-face {
		font-family: "PMZD";
		src: url("~@/assets/font/PMZD.ttf");
	}

	@font-face {
		font-family: "HT";
		src: url("~@/assets/font/HT.ttf");
	}

	@-webkit-keyframes rotation {

		from {
			-webkit-transform: rotate(0deg);
		}

		to {
			-webkit-transform: rotate(360deg);
		}

	}

	.screen-wrapper2 {
		height: 100%;
		width: 100%;
		font-size: 20px;
		background-color: #000000;
		color: #ffffff;

		.DS-Digital-Bold {
			font-family: "DS-Digital-Bold";
		}

		.screenBg {
			// background-image: url("~@/assets/images/exposition/senceBg.png");
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}

		.screen {
			overflow: hidden;
			display: inline-block;
			width: 4576px;
			height: 1935px;
			transform-origin: 0 0;
			position: absolute;
			left: 50%;
			// background: url("~@/assets/images/exposition/xunidianchangJiangsu.png");
			// background: url("~@/assets/images/exposition/xunidianchangsuzhou.png");
			// background-color: yellow;

			.demo-root {
				position: relative;

				.all {
					position: absolute;
					top: 0;
					left: 0;
					width: 4576px;
					// height: 100px;
					// background-color: pink;

					.video {
						width: 4576px;
					}
				}

				header {
					width: 4576px;
					height: 245px;
					// background-color: pink;
					text-align: center;
				}

				main {
					height: 1690px;
					display: flex;
					// margin-bottom: 169px;
					// background-color: blue;


					.demo-left {
						width: 2328px;
						height: 1939px;
						//   display: flex;
						// background-color: green;
						position: relative;

						.demo-left-top {
							height: 190px;
							width: 100%;
							// background-color: goldenrod;
							// opacity:0.6;  
						}

						.demo-left-center {
							width: 100%;
							height: 100px;
						}

						.demo-left-bottom2 {
							position: absolute;
							height: 157px;
							width: 2189px;
							bottom: 100px;
							left: 30px;

							// 
							.shuliangtongji {
								position: absolute;
								width: 285px;
								height: 297px;
								left: 25px;
								bottom: 370px;
								// background-color: rgb(149, 183, 233);
								z-index: 10001;

								.lefttitle {
									height: 99px;
									display: flex;

									.title {
										letter-spacing: 1px;
										width: 100px;
										display: block;
										font-size: 32px;
										font-family: "PMZD";
										font-weight: bold;
										margin-left: 34px;
										margin-right: 10px;

									}

									.num {
										display: block;
										font-size: 48px;
										color: #F0F09E;
										margin-right: 10px;
										font-family: "HT";
									}

									.danwei {
										width: 50px;
										display: block;
										font-size: 24px;

									}

								}

								.lineHight1 {
									line-height: 70px;
								}

								.lineHight2 {
									line-height: 119px;

									.title {
										color: #00FFFF;
									}
								}

								.lineHight3 {
									line-height: 167px;

									.title {
										color: #00C2FF;
									}
								}

							}

							.yellow1 {
								position: absolute;
								left: 174px;
								bottom: 580px;
								height: 99px;
								width: 99px;
								background: url("~@/assets/images/exposition/yellow.png")no-repeat;
								background-size: 100% 100%;
							}

							.yellow2 {
								position: absolute;
								left: 174px;
								bottom: 340px;
								height: 99px;
								width: 99px;
								background: url("~@/assets/images/exposition/yellow.png")no-repeat;
								background-size: 100% 100%;
							}

							.yellow3 {
								position: absolute;
								left: 174px;
								bottom: 460px;
								height: 99px;
								width: 99px;
								background: url("~@/assets/images/exposition/yellow.png")no-repeat;
								background-size: 100% 100%;
							}

							.suanlishuliangbiaozhu {
								position: absolute;
								width: 59px;
								height: 297px;
								left: 25px;
								bottom: 370px;
								background: url("~@/assets/images/exposition/suanlishuliangbiaozhu.png")no-repeat;
								background-size: 100% 100%;
								z-index: 10000;
							}

							.robotButton {
								z-index: 1000009;
								display: flex;
								position: absolute;
								left: 127%;
								bottom: 200px;
								width: 190px;
								height: 100px;
								background-image: url("~@/assets/images/exposition/shuzirenBtn.png");
								background-repeat: no-repeat;
								background-size: 100% 100%;

								.shuzirenRound {
								
									border-radius: 50%;
									width: 100px;
									height: 100px;
									background-image: url("~@/assets/images/exposition/shuzirenRound.png");
									background-repeat: no-repeat;
									background-size: 100% 100%;
								    .shuzirenRoundImg{
										display: block;
										width: 95px;
										height: 95px;
										border-radius: 50%;
									} 
								
								
								}

								.title {
									font-size: 36px;
									font-weight: 500;
									color: #00FDF4;
									line-height: 100px;
									margin-left: 10px;
								}

								.shuzirenIcon1 {
									margin-top: 20px;
									margin-left: 10px;

									.shuzirenIconImg {

										display: block;
										width: 60px;
										height: 60px;
									}
								}
							}
						}
					}

					.demo-right2 {
						width: 2248px;
						//   display: flex;
						height: 1690px;

						// background-color: gray;
						.demo-right-top2 {
							height: 750px;
							width: 2248px;
							// background-color: rgb(163, 230, 178);
						}

						.demo-right-bottom2 {
							position: relative;
							height: 770px;
							width: 2248px;
							// background-color: rgb(241, 178, 226);

						}
					}
				}

				// footer {
				//   width: 100%;
				//   height: 110px;
				//   font-size: 40px;
				//   text-align: center;
				//   line-height: 110px;
				//   background: rgba(122, 194, 204, 0.3);
				// }
			}

			.robot {
				position: absolute;
				bottom: 180px;
				width: 4000px;
				height: 100px;
				// background-color: #13262f;
				z-index: 999999999999;


				.rightBtn {
					display: flex;
					position: absolute;
					right: 80px;
					top: 500px;
					width: 300px;
					height: 80px;
					background-image: url("~@/assets/images/exposition/rightBtn.png");
					background-repeat: no-repeat;
					background-size: 100% 100%;

					.rightBtnImg {
						display: block;
						width: 60px;
						height: 60px;
						margin-top: 12px;
						margin-left: 10px;
						-webkit-transform: rotate(360deg);

						animation: rotation 3s linear infinite;

						-moz-animation: rotation 3s linear infinite;

						-webkit-animation: rotation 3s linear infinite;

						-o-animation: rotation 3s linear infinite;
					}

					.title {
						font-size: 32px;
						font-weight: 500;
						color: #00FDF4;
						line-height: 80px;
					}
				}
			}
		}
	}
</style>